import { useMemo } from 'react';
import { UserStatus } from '../../types/user';
export function useLayoutNavigation(user) {
  var hasRestrictedAccess = useMemo(function () {
    return ![UserStatus.APPROVED, UserStatus.PREAPPROVED, UserStatus.VETTING].includes(user === null || user === void 0 ? void 0 : user.status);
  }, [user === null || user === void 0 ? void 0 : user.status]);
  return {
    hasRestrictedAccess: hasRestrictedAccess
  };
}